import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {Validate} from "../../core/form/validate";
import {MdCheckbox, MdTextField} from "../../core/components/fields/fields";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import StyledSelect from "../../core/components/fields/styledSelect";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {PROJECT_MATERIAL_ENTITY, PROJECT_VERSION_ROOM_ENTITY} from "../entityConstants";
import {ProjectVersion} from "../domain/project/projectVersionDomain";
import {ProjectVersionWindow} from "../domain/project/projectVersionWindowDomain";
import {IsRequired, Min, IsNumber, Max} from "../../core/form/rules";
import {BlockComp} from "../../core/components/blockComp/blockComp";

@observer
class ProjectVersionWindowForm extends React.Component<FormProps<ProjectVersionWindow, ProjectVersion>, undefined> {


  render() {

    let {dataObject, rootObject, entities, entity} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionWindowFormDefinition.formName);
    let {name, displacement, room, reachableOnlyByLadder, securityType, height, width, glassArea,
      frameLength, angleAlpha, angleBeta, angleDelta, angleEpsilon, angleGama, angleEta, angleZeta, angleShadowZ,
      frameMaterial, frameMaterialWeight, glassMaterial, glassMaterialWeight} = fields;

    return (
      <BlockComp noPadding>
        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...name.props} />
            <Validate field={name} value={name.props.value}>
              <IsRequired/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...displacement.props} />
            <Validate field={displacement} value={displacement.props.value}>
              <IsRequired/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...room.props} async={true} asterixForAll loadOptions={optionsSearch.bind(this, PROJECT_VERSION_ROOM_ENTITY, {projectVersionId : rootObject.versionId})} clearable={true} />
            <Validate field={room} value={room.props.value}>
              <IsRequired/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-2" style={{marginTop : "10px"}}>
            <MdCheckbox {...reachableOnlyByLadder.props}/>
            <Validate field={reachableOnlyByLadder} value={reachableOnlyByLadder.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-1">
            <StyledSelect {...securityType.props}/>
            <Validate field={securityType} value={securityType.props.value}>
              <IsRequired/>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...frameMaterial.props} async={true} asterixForAll loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : rootObject.versionId})} clearable={true} />
            <Validate field={frameMaterial} value={frameMaterial.props.value}>
              <IsRequired/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...frameMaterialWeight.props} />
            <Validate field={frameMaterialWeight} value={frameMaterialWeight.props.value}>
              <IsRequired/>
              <Min min={0}/>
              <IsNumber/>
            </Validate>
          </div>

          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...glassMaterial.props} async={true} asterixForAll loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : rootObject.versionId})} clearable={true} />
            <Validate field={glassMaterial} value={glassMaterial.props.value}>
              <IsRequired/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...glassMaterialWeight.props} />
            <Validate field={glassMaterialWeight} value={glassMaterialWeight.props.value}>
              <IsRequired/>
              <Min min={0}/>
              <IsNumber/>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...height.props} />
            <Validate field={height} value={height.props.value}>
              <IsRequired/>
              <Min min={0}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...width.props}/>
            <Validate field={width} value={width.props.value}>
              <IsRequired/>
              <Min min={0}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...glassArea.props}/>
            <Validate field={glassArea} value={glassArea.props.value}>
              <IsRequired/>
              <Min min={0}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...frameLength.props}/>
            <Validate field={frameLength} value={frameLength.props.value}>
              <IsRequired/>
              <Min min={0}/>
              <IsNumber/>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...angleAlpha.props} />
            <Validate field={angleAlpha} value={angleAlpha.props.value}>
              <Min min={0}/>
              <Max max={360}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...angleBeta.props}/>
            <Validate field={angleBeta} value={angleBeta.props.value}>
              <Min min={0}/>
              <Max max={360}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...angleGama.props}/>
            <Validate field={angleGama} value={angleGama.props.value}>
              <Min min={0}/>
              <Max max={360}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...angleDelta.props}/>
            <Validate field={angleDelta} value={angleDelta.props.value}>
              <Min min={0}/>
              <Max max={360}/>
              <IsNumber/>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...angleEpsilon.props} />
            <Validate field={angleEpsilon} value={angleEpsilon.props.value}>
              <Min min={0}/>
              <Max max={360}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...angleZeta.props}/>
            <Validate field={angleZeta} value={angleZeta.props.value}>
              <Min min={0}/>
              <Max max={360}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...angleEta.props}/>
            <Validate field={angleEta} value={angleEta.props.value}>
              <Min min={0}/>
              <Max max={360}/>
              <IsNumber/>
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...angleShadowZ.props}/>
            <Validate field={angleShadowZ} value={angleShadowZ.props.value}>
              <Min min={0}/>
              <Max max={360}/>
              <IsNumber/>
            </Validate>
          </div>
        </div>
      </BlockComp>
    );
  }
}


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ProjectVersionWindow>) => (
  <div style={{width: '100%'}}>
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.name.textLabel} value={dataObject.name}/>
      <ClosedFormField label={fields.displacement.textLabel} value={dataObject.displacement}/>
      <ClosedFormField label={fields.room.textLabel} value={dataObject.room}/>
      <ClosedFormField label={fields.reachableOnlyByLadder.textLabel} value={dataObject.reachableOnlyByLadder}/>
      <ClosedFormField label={fields.securityType.textLabel} value={dataObject.securityType}/>
      <ClosedFormField label={fields.height.textLabel} value={dataObject.height}/>
      <ClosedFormField label={fields.glassArea.textLabel} value={dataObject.glassArea}/>
      <ClosedFormField label={fields.frameLength.textLabel} value={dataObject.frameLength}/>
      <ClosedFormField label={fields.angleAlpha.textLabel} value={dataObject.angleAlpha}/>
      <ClosedFormField label={fields.angleBeta.textLabel} value={dataObject.angleBeta}/>
      <ClosedFormField label={fields.angleGama.textLabel} value={dataObject.angleGama}/>
      <ClosedFormField label={fields.angleDelta.textLabel} value={dataObject.angleDelta}/>
      <ClosedFormField label={fields.angleEpsilon.textLabel} value={dataObject.angleEpsilon}/>
      <ClosedFormField label={fields.angleZeta.textLabel} value={dataObject.angleZeta}/>
      <ClosedFormField label={fields.angleEta.textLabel} value={dataObject.angleEta}/>
      <ClosedFormField label={fields.angleShadowZ.textLabel} value={dataObject.angleShadowZ}/>
      <ClosedFormField label={fields.frameMaterial.textLabel} value={dataObject.frameMaterial}/>
      <ClosedFormField label={fields.frameMaterialWeight.textLabel} value={dataObject.frameMaterialWeight}/>
      <ClosedFormField label={fields.glassMaterial.textLabel} value={dataObject.glassMaterial}/>
      <ClosedFormField label={fields.glassMaterialWeight.textLabel} value={dataObject.glassMaterialWeight}/>
    </ClosedFormBlock>
  </div>
);


export const ProjectVersionWindowFormDefinition: DefinitionType = {
  formName: 'ProjectVersionWindowForm',
  fields: [
    {name : "name"},
    {name : "displacement"},
    {name : "room"},
    {name : "reachableOnlyByLadder"},
    {name : "securityType"},
    {name : "height"},
    {name : "width"},
    {name : "glassArea"},
    {name : "frameLength"},
    {name : "angleAlpha"},
    {name : "angleBeta"},
    {name : "angleGama"},
    {name : "angleDelta"},
    {name : "angleEpsilon"},
    {name : "angleZeta"},
    {name : "angleEta"},
    {name : "angleShadowZ"},
    {name : "frameMaterial"},
    {name : "frameMaterialWeight"},
    {name : "glassMaterial"},
    {name : "glassMaterialWeight"}
  ]
};

export default createForm(ProjectVersionWindowFormDefinition, ClosedContent)(ProjectVersionWindowForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionWindowForm.tsx